/**
 * Normalize an address part for equality checks.
 * Contacts/names are intentionally ignored — addresses only.
 */
export function normalizeAddressPart(value) {
    return String(value ?? '')
        .trim()
        .toLowerCase()
        .replace(/[.,#]/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();
}

/**
 * Build a comparable fingerprint for a shipping location.
 * Uses street lines + city/state/postal only.
 */
export function buildAddressFingerprint(address = {}) {
    const line1 = normalizeAddressPart(address.address1 ?? address.originAddress1 ?? address.destinationAddress1);
    const line2 = normalizeAddressPart(address.address2 ?? address.originAddress2 ?? address.destinationAddress2);
    const city = normalizeAddressPart(address.city ?? address.originCity ?? address.destinationCity);
    const state = normalizeAddressPart(address.state ?? address.originState ?? address.destinationState);
    const postal = normalizeAddressPart(address.postalCode ?? address.originPostalCode ?? address.destinationPostalCode)
        .replace(/\s+/g, '');

    // Require at least a primary street line before treating as a match candidate.
    if (!line1) return '';

    return [line1, line2, city, state, postal].join('|');
}

/**
 * True when origin and destination describe the same physical address.
 */
export function areOriginDestinationAddressesSame(origin = {}, destination = {}) {
    const originKey = buildAddressFingerprint(origin);
    const destinationKey = buildAddressFingerprint(destination);
    if (!originKey || !destinationKey) return false;
    return originKey === destinationKey;
}

export const ORIGIN_DESTINATION_SAME_ADDRESS_MESSAGE =
    'Origin and destination addresses cannot be the same. Please use different addresses.';
